import { combineReducers } from "redux";

import {
    FETCH_EVENTS,
    FETCH_LESSONS,
    CREATE_CUSTOM_DEMO,
    CHANGE_CUSTOM_DEMO,
    CHANGE_DATE,
    SELECT_DEMO_ITEM
} from './action-types';
import { fulfilled, pending, rejected } from '../utils/actions';

function events(state = [], action) {
    switch (action.type) {
        case fulfilled(FETCH_EVENTS):
            return action.payload;
        default:
            return state;
    }
}

function items(state = [], action) {
    switch (action.type) {
        case fulfilled(FETCH_LESSONS):
            return action.payload;
        default:
            return state;
    }
}

function loadingItems(state = false, action) {
    switch (action.type) {
        case fulfilled(FETCH_LESSONS):
            return false;
        case pending(FETCH_LESSONS):
            return true;
        case rejected(FETCH_LESSONS):
            return false;
        default:
            return state;
    }
}

function loadingEvents(state = false, action) {
    switch (action.type) {
        case fulfilled(FETCH_EVENTS):
            return false;
        case pending(FETCH_EVENTS):
            return true;
        case rejected(FETCH_EVENTS):
            return false;
        default:
            return state;
    }
}

function currentItem(state = {}, action) {
    switch (action.type) {
        case SELECT_DEMO_ITEM:
            return action.payload;
        default:
            return state;
    }
}

function date(state = null, action) {
    switch (action.type) {
        case CHANGE_DATE:
            return action.payload;
        default:
            return state;
    }
}

function customDemo(state = {}, action) {
    switch (action.type) {
        case fulfilled(CREATE_CUSTOM_DEMO):
            return { ...state, __sent: true, __sending: false };
        case pending(CREATE_CUSTOM_DEMO):
            return { ...state, __sending: true };
        case CHANGE_CUSTOM_DEMO:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default combineReducers({
    events,
    items,
    loadingItems,
    currentItem,
    date,
    customDemo,
    loadingEvents
});



// WEBPACK FOOTER //
// ./src/demo_new/reducers.js